<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{ title }}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
    </h1>
    <div class="scroll" fxFlex.gt-sm="auto">
        <div [innerHTML]="message | safeHTML"></div>
        <form [formGroup]="inputForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label *ngIf="inputprefix">{{ inputprefix }}</app-form-label>
                <mat-form-field *ngIf="timeeditable" appearance="outline" class="fullwidth" fxFlex>
                    <input matInput type="text" name="JobTime" formControlName="JobTime" />
                    <mat-hint *ngIf="inputhint">{{ inputhint }}</mat-hint>
                    <mat-error *ngIf="inputForm?.get('JobTime')?.hasError('required')">Required.</mat-error>
                    <mat-error *ngIf="inputForm?.get('JobTime')?.hasError('pattern')">Invalid format.</mat-error>
                </mat-form-field>
                <div *ngIf="!timeeditable">{{ inputForm?.get('JobTime')?.value }}</div>
            </div>

            <div *ngIf="textboxprefix" [innerHTML]="textboxprefix | safeHTML"></div>
            <mat-form-field appearance="outline" class="fullwidth">
                <textarea
                    matInput
                    formControlName="OptionalComment"
                    aria-label="Text entry space"
                    [placeholder]="placeholderText"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="4"
                ></textarea>
            </mat-form-field>
        </form>
    </div>
    <div
        class="actionbar"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="15px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
    >
        <button mat-raised-button type="button" color="warn" (click)="CancelHandler()">{{ canceltext }}</button>
        <button mat-raised-button type="button" color="primary" (click)="OKHandler()" [disabled]="!inputForm.valid">
            {{ oktext }}
        </button>
    </div>
</div>
